import moment from 'moment';
import { Button } from '../common/Button';
import shareImg from '../../styles/share_button.png';
import { Tag } from 'react-tag-autocomplete';
import React from 'react';
import { TagInput } from '../common/TagInput';

// @ts-ignore
export default (onClickHandler, activeIndex, onTagClickHandler, suggestions: Tag[] | []) => {
    return [
        {
            name: 'Share',
            // @ts-ignore
            cell: (row, index, column, id) => {
                return <Button type="button" className="image" onClick={() => {
                    onClickHandler(row)
                }}><img src={shareImg}/></Button>
            }
        },
        {
            name: 'Assessment date',
            id: 'assessmentDate',
            // @ts-ignore
            selector: row => row.assessmentDate,
            // @ts-ignore
            format: row => {
                const dateTimeSplit = row.assessmentDate.split(' ')
                const parts = dateTimeSplit[0].split('-')
                return `${parts[2]}-${parts[1]}-${parts[0]} ${dateTimeSplit[1]}`;
            },
            sortable: true
        },
        {
            name: 'Institute',
            id: 'companyParentName',
            // @ts-ignore
            selector: row => {

                return row.companyParentName.charAt(0).toUpperCase() + row.companyParentName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Company',
            id: 'companyName',
            // @ts-ignore
            selector: row => {
                if(!row.companyName) return row.companyName
                return row.companyName.charAt(0).toUpperCase() + row.companyName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Label',
            id: 'label',
            // @ts-ignore
            selector: row => {
                // @ts-ignore
                return row.tags.map(tag => tag.name.toLowerCase()).join('')
            },
            // @ts-ignore
            format: row => {
                // @ts-ignore
                return row.tags.map(tag => tag.name).join(', ')
            },
            sortable: true,
            // @ts-ignore
            cell: (row, index) => {
                return <TagInput
                    rowIndex={index}
                    currentActiveRowIndex={activeIndex}
                    setCurrentActiveRowIndex={onTagClickHandler}
                    suggestions={suggestions}
                    entityId={row.id}
                    type={'ASSESSMENT'}
                    row={row}
                />
            }
        },
        {
            name: 'Contact',
            id: 'contactPerson',
            // @ts-ignore
            selector: row => row.contactPerson,
            // @ts-ignore
            format: row => {
                return row.contactPerson !== null ? row.contactPerson : '-'
            },
            sortable: true
        }, {
            name: 'Founder',
            id: 'founder',
            // @ts-ignore
            selector: row => row.founder,
            // @ts-ignore
            format: row => {
                return row.founder ? row.founder : '-'
            },
            sortable: true
        },
        // {
        //     name: 'Founding date',
        //     id: 'foundingDate',
        //     // @ts-ignore
        //     selector: row => row.foundingDate,
        //     // @ts-ignore
        //     format: row => {
        //         if(!row.foundingDate) {
        //             return '-'
        //         }
        //         const date = moment(`${row.foundingDate}-01`)
        //         date.locale('nl')
        //         return date.format('MMM YYYY')
        //     },
        //     sortable: true,
        //     style: {
        //         minWidth: "40px"
        //     }
        // },
        // {
        //     name: 'Sector',
        //     id: 'sector',
        //     // @ts-ignore
        //     selector: row => row.sector,
        //     // @ts-ignore
        //     format: row => {
        //         if(!row.sector) return row.sector
        //         return row.sector !== null
        //             ? row.sector.charAt(0).toUpperCase() + row.sector.slice(1)
        //             : '-'
        //     },
        //     sortable: true
        // },
        {
            name: 'Scan',
            id: 'pdfUrl',
            // @ts-ignore
            selector: row => row.pdfUrl,
            sortable: false,
            cell: (data: any) => {
                let link = data.pdfUrl
                if(link && !link.includes('http')) link = process.env.REACT_APP_STORAGE_URL + data.pdfUrl
                let text = 'ConsistencyScan'
                if(data.link && data.link.includes('discovery')) {
                    text = 'DiscoveryScan'
                }
                return (data.pdfUrl ? <a href={link} target="_blank"> {text} </a> : '-')
            }
        },
        {
            name: 'Questionaire',
            id: 'questionnairePdfUrl',
            // @ts-ignore
            selector: row => row.questionnairePdfUrl,
            sortable: false,
            cell: (data: any) => {
                let link = data.questionnairePdfUrl
                if(link && !link.includes('http')) link = process.env.REACT_APP_STORAGE_URL + data.questionnairePdfUrl
                return (data.questionnairePdfUrl ? <a href={link} target="_blank"> link </a> : '-')
            }
        },
    ];
}
